<em-main>
  <div class="layout--column layout--gap-larger">
    <div class="justify-content-between layout--row">
      <h2 i18n>Rapport MIB</h2>
    </div>
    @if (data$ | async; as data) {
      @for (reply of data.mibReplies ?? []; track reply; let i = $index) {
        <p-card class="p-card container">
          <h3
            >{{ getFullName(reply) }}
            <span class="text-lg"
              >({{ reply.type }} -
              {{
                reply.qualityMatchProbability ? (reply.qualityMatchProbability | percent: '1.1-5') : 'N/A'
              }})
            </span></h3
          >
          <em-details-section [data]="reply"></em-details-section>
          <em-coded-report-section [data]="reply.mibCodedReports ?? []"></em-coded-report-section>
          <em-iai-section [data]="reply.mibIAIReports ?? []"></em-iai-section>
        </p-card>
      }
    } @else {
      <em-skeleton></em-skeleton>
    }
  </div>
</em-main>
